<script>
    import { user, loggedInDoctorDetail } from "../../stores";

    import { PageHead } from "../../Components/Common/index.svelte";

    import CreateQuoteSection from "./components/CreateQuoteSection.svelte";
    import EditQuoteSection from "./components/EditQuoteSection.svelte";

    export let params = {};

    let isCreateFlow = false,
        isEditDuplicate = false,
        isDuplicateFromTable = true;

    $: if (params && params.id) isCreateFlow = false;
    else isCreateFlow = true;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (!isCreateFlow) isEditDuplicate = !!params.query ?? false;

    $: if (isEditDuplicate)
        isDuplicateFromTable = params.query.split("=")[1] == 1;

    $: pageHeadTitle = isCreateFlow
        ? $user.role == 2
            ? "Create New Fee Estimate"
            : isFlowEnableSearchDoctor
              ? $loggedInDoctorDetail.id
                  ? `Create New Fee Estimate for ${$loggedInDoctorDetail.fullName}`
                  : "Create New Fee Estimate"
              : "Create New Fee Estimate"
        : `${isEditDuplicate ? "Duplicate" : "Edit"} Patient Fee Estimate`;
</script>

<PageHead title={pageHeadTitle} />

<div class="relative flex-1 overflow-y-auto">
    <div class="absolute inset-0 flex-1">
        {#if isCreateFlow}
            <CreateQuoteSection {params} />
        {:else}
            <EditQuoteSection
                {isEditDuplicate}
                {isDuplicateFromTable}
                patientEncounterId={params.id}
            />
        {/if}
    </div>
</div>
